;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useEffect, useState } from 'react';
import { Button, ModalBody, ModalFooter } from 'reactstrap';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { orderBy } from 'lodash';
import FormikMultiSelectInput from '../../forms/inputs/FormikMultiSelectInput';
import functionNodes, { functionOptions } from '../../../utils/carerix/dataNodes/function';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import { getCandidate, saveCandidate } from '../../../api/candidate';
import { useUser } from '../../../contexts/UserContext';
import { logSentryError } from '../../../utils/logSentry';
import FormAlert from '../../forms/FormAlert';
import { Dictionaries } from '../../../i18n/i18n-config';
import { useParams } from 'next/navigation';
import { getI18nUtils } from '../../../i18n/i18n-utils';

const validationSchema = yup.object({
  functions: yup.array().of(yup.string().oneOf(functionNodes)),
});

type JobPreferenceInputs = yup.InferType<typeof validationSchema>;

const initialValues: JobPreferenceInputs = { functions: [] };

type Props = {
  dictionary: Partial<Dictionaries>;
  next: () => void;
  prev: () => void;
};
function ProfileModalFunctions({ next, prev, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale } = useParams();
  const { candidate, setCandidate } = useUser();
  const [alert, setAlert] = useState<{
    type: 'success' | 'warning' | 'danger';
    message: string;
  } | null>(null);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, actions) => {
      try {
        const data = { jobPreferences: { functions: values.functions } };
        await saveCandidate(data, 'acquaintance');
        // "silent" refresh of context
        const c = await getCandidate();
        setCandidate(c);
        actions.setSubmitting(false);
        actions.resetForm();
        next();
      } catch (e: any) {
        setAlert({ type: 'danger', message: 'internal-server-error' });
        actions.setSubmitting(false);
        logSentryError(e);
      }
    },
  });

  useEffect(() => {
    const { functions } = candidate?.jobPreferences || {};
    formik.setValues({ functions: functions || initialValues.functions });
  }, [candidate]);

  const getOptions = (nodes: any[]) =>
    orderBy(
      nodes.map((dl) => ({
        value: dl.value,
        label: capitalizeFirstLetter(dl.labels.find(({ language }) => language === locale)?.label),
      })),
      ['label']
    );
  const functionSelect = getOptions(functionOptions);

  const { isSubmitting, handleSubmit } = formik;

  return (
    <>
      <ModalBody>
        <div className="py-4">
          <h2 className="d-block mb-3">{formatMessage({ id: 'profile_form_functions_title' })}</h2>
          <p>{formatMessage({ id: 'profile_form_functions_intro' })}</p>

          <FormikMultiSelectInput
            dictionary={dictionary}
            className="mb-3"
            formik={formik}
            name="functions"
            intlKey="candidate_expectations_functions"
            options={functionSelect}
            disabled={isSubmitting}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <FormAlert dictionary={dictionary} className="flex-grow-1 mb-2" alert={alert} />
        <Button disabled={isSubmitting} color="primary" className="w-100" onClick={() => handleSubmit()}>
          {formatMessage({ id: 'next' })}
        </Button>
        <Button disabled={isSubmitting} color="white" className="mt-3 mx-auto d-block" onClick={() => prev()}>
          {formatMessage({ id: 'previous' })}
        </Button>
      </ModalFooter>
    </>
  );
}

export default ProfileModalFunctions;
